import React from 'react';
import { Route, Switch } from 'react-router-dom';
import ReactRouterPropTypes from 'react-router-prop-types';
import ProjectsWithUsersList from './routes/user-list';
import WhenNotFound from '../../../shared/whenNotFound';
import AssignUser from './routes/assign-user';
import UserEdit from './routes/user-edit';

const UserManagement = ({ match }) => (
  <Switch>
    <Route exact path={`${match.url}/`} component={ProjectsWithUsersList} />
    <Route exact path={`${match.url}/user-list`} component={ProjectsWithUsersList} />
    <Route exact path={`${match.url}/assign-user`} component={AssignUser} />
    <Route exact path={`${match.url}/account-settings`} component={UserEdit} />
    <Route exact path={`${match.url}/account-settings/:inProjectId/:userId`} component={UserEdit} />
    <Route component={WhenNotFound} />
  </Switch>
);

UserManagement.propTypes = {
  match: ReactRouterPropTypes.match.isRequired,
};

export default UserManagement;
